import { useId } from 'react'
import './WaterDailyGauge.css'

function litersLabel(value) {
  const number = Number(value)
  const safe = Number.isFinite(number) ? number : 0
  return safe.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
}

function WaterDailyGauge({ liters = 0, percent = 0 }) {
  const rawId = useId().replace(/:/g, '')
  const gradientId = `water-gauge-gradient-${rawId}`
  const shadowId = `water-gauge-shadow-${rawId}`
  const cx = 120
  const cy = 118
  const radius = 86
  const clamped = Math.max(0, Math.min(Number(percent) || 0, 100))
  const angle = Math.PI * (1 - clamped / 100)
  const tip = {
    x: cx + (radius - 4) * Math.cos(angle),
    y: cy - (radius - 4) * Math.sin(angle)
  }
  const tail = {
    x: cx + (radius - 30) * Math.cos(angle),
    y: cy - (radius - 30) * Math.sin(angle)
  }
  const shown = Math.max(0, Math.round(Number(percent) || 0))

  return (
    <article className="hydration-card water-gauge" aria-label="Média geral diária de água">
      <h2>Média geral diária</h2>
      <svg viewBox="0 0 240 168" preserveAspectRatio="xMidYMid meet" role="img" aria-label={`${litersLabel(liters)} litros por dia, ${shown}% da meta diária`}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#075985" />
            <stop offset="48%" stopColor="#0284c7" />
            <stop offset="100%" stopColor="#bae6fd" />
          </linearGradient>
          <filter id={shadowId} x="-20%" y="-30%" width="140%" height="170%">
            <feDropShadow dx="0" dy="3" stdDeviation="2.4" floodColor="#0369a1" floodOpacity="0.38" />
          </filter>
        </defs>
        <path
          d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
          className="water-gauge-track"
        />
        <path
          d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
          className="water-gauge-arc"
          stroke={`url(#${gradientId})`}
          filter={`url(#${shadowId})`}
        />
        <line className="water-gauge-needle" x1={tail.x} y1={tail.y} x2={tip.x} y2={tip.y} />
        <circle className="water-gauge-hub" cx={cx} cy={cy} r="5" />
        <text className="water-gauge-value" x={cx} y={cy - 48} textAnchor="middle">{litersLabel(liters)}</text>
        <text className="water-gauge-unit" x={cx} y={cy - 28} textAnchor="middle">Litros/Dia</text>
        <text className="water-gauge-meta" x={cx} y={cy - 12} textAnchor="middle">{`(${shown}% da meta diária)`}</text>
      </svg>
    </article>
  )
}

export default WaterDailyGauge
